var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('iframe',{attrs:{"width":"100%","height":"100%","id":"mainframe","scrolling":"no","frameborder":"no","title":"Inline Frame Example","allow":"microphone","src":`https://ll-livespeaking.liveabc.com/AIStorybook/reader/${_vm.$route.params.bookId}`}})])
}
var staticRenderFns = []

export { render, staticRenderFns }